module.exports = __webpack_public_path__ + "static/slider-3-teal-molding-accessory-23508b4f4ced972c6410ca68748cf50f.png";